<template>
  <div class="shoppinglist-share-container">
    <h4 class="desktop" v-if="sharepage">
      {{ $l("listpageShareHeadline") }}
    </h4>

    <h4 class="desktop" v-else>
      {{ $l("sharingHeadline") }}
    </h4>

    <h4 class="mobile" v-if="sharepage">
      {{ $l("listpageShareHeadline") }}
    </h4>

    <h4 class="mobile" v-else>
      {{ $l("sharingHeadline") }}
    </h4>

    <div class="button-container">
      <button
        class="button-primary"
        v-on:click.prevent="open"
      >
        Teilen <i class="icon-share" aria-hidden="true"></i>
      </button>
      <button
        class="button-primary desktop print-button"
        v-on:click.prevent="openPrint"
      >
        Drucken <i class="icon-print" aria-hidden="true"></i>
      </button>
    </div>
    <p v-if="sharepage">
      {{ $l("listpageShareCopy") }}
    </p>
    <p v-else>
      {{ $l("sharingCopy") }}
    </p>
    <SharePopup
      v-if="openPopup"
      :shareUrl="shareUrl"
      :sharepage="sharepage"
      @close="close"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import CloseButton from "@/components/CloseButton.vue";
import SharePopup from "@/components/SharePopup.vue";
export default {
  name: "shoppinglist-share-container",
  components: {
    CloseButton,
    SharePopup
  },
  props: {
    sharepage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      openPopup: false,
      copied: false
    };
  },
  methods: {
    openPrint() {
      this.$trackCustomEvent('click_feuerwerk2025_merkliste-drucken');

      const listKey =
        this.$route.name === "shoppinglist"
          ? this.$route.params.key
          : this.shoppinglistKey;

      const routeData = this.$router.resolve({
        name: "print",
        params: { key: listKey }
      });
      window.open(routeData.href, "_blank");
    },
    open() {
      this.$trackCustomEvent('click_feuerwerk2025_merkliste-teilen');
      this.openPopup = true;
    },
    close() {
      this.openPopup = false;
    }
  },
  computed: {
    ...mapState(["shoppinglistKey"]),
    shareUrl() {
      if (this.sharepage && this.$route.params && this.$route.params.key) {
        return `${process.env.VUE_APP_SHARE_URL}/${this.$route.params.key}`;
      } else {
        return `${process.env.VUE_APP_SHARE_URL}/${this.shoppinglistKey}`;
      }
    }
  }
};
</script>

<style lang="scss">
@import "./ShoppinglistShare";
</style>
